<template>
  <div id="app">
    <Header
      :class="[scrollStep <= 0 ? 'headerStyle1' : 'headerStyle2']"
    ></Header>
    <router-view :class="[scrollStep <= 0 ? 'routerView1' : 'routerView2']" />
    <GoTop></GoTop>
    <Footer></Footer>
   
  </div>
</template>

<script>
import DevicePixelRatio from './utils/devicePixelRatio'
export default {
  name: "App",
  data() {
    return {
      // 滚动前，滚动条距文档顶部的距离
      oldScrollTop: 0,
      scrollStep: 0,
      headerStyle: {
        position: "fixed",
        top: "0",
        zIndex: "999",
        width: "100%"
      }
    };
  },
  created() {
    new DevicePixelRatio().init();
  },
  mounted() {
    // 监听页面滚动事件
    window.addEventListener("scroll", this.scrolling);
    // window.onresize = () => {
    //   return (() => {
    //     this.detectZoom()
    //   })()
    // };
    // var browerWidth = window.innerWidth; //浏览器可视宽度
    // var baseWidth = 1920; //设计稿宽度
    // var zoomValue = browerWidth / baseWidth; //缩放比例计算
    // document.getElementById("mainContainer").style.transform = "scale(" + zoomValue + "," + zoomValue + ")"; //mainContainer为主容器id
    // window.onresize = function () { //窗口尺寸变化时，重新计算和缩放
    //   browerWidth = window.innerWidth;
    //   zoomValue = browerWidth / baseWidth;
    //   document.getElementById("mainContainer").style.transform = "scale(" + zoomValue + "," + zoomValue + ")";
    // }
  },
  methods: {
    scrolling() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 滚动条滚动的距离
      this.scrollStep = scrollTop - this.oldScrollTop;
      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop;
      if (this.scrollStep < 0) {
      } else {
      }
    },
    detectZoom (){ 
      var ratio = 0,
      screen = window.screen,
      ua = navigator.userAgent.toLowerCase();
      if (window.devicePixelRatio !== undefined) {
          ratio = window.devicePixelRatio;
      }
      else if (~ua.indexOf('msie')) {  
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      }
      else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth;
      }
      
      if (ratio){
        ratio = Math.round(ratio * 100);
      }
      //ratio就是获取到的百分比
      this.onresize_height = ratio
      // return ratio;
    },
  }
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  border: 0;
  overflow-x: hidden;
}
#app {
  width: 100%;
  background: url("./assets/img/otherbj.jpg");
  justify-content: center;
  /* align-items: center; */
  position: relative;
  height: 100%;
  background-size: 100% 100%;
}
.headerStyle1 {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
}
.headerStyle2 {
  transform: translateY(-140px);
}
.routerView1 {
  width: 100%;
  margin-top: 140px;
}
.routerView2 {
  width: 100%;
  margin-top: -140px;
}

/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */

@media screen and (max-width: 997px) {
  .routerView1 {
  width: 100%;
  margin-top: 50px;
}
}
</style>



// WEBPACK FOOTER //
// src/App.vue